import { Spin } from "antd";
import React from "react";
import { LoadingOutlined, InstagramOutlined } from "@ant-design/icons";

const LoadingC = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <Spin
        indicator={
          <>
            <InstagramOutlined style={{ fontSize: 50 }} spin />
            {/* <LoadingOutlined style={{ fontSize: 50 }} spin /> */}
          </>
        }
      />
    </div>
  );
};

export default LoadingC;
